import React from 'react';

// A small helper that adds a .preload() method to a lazy component
export function lazyWithPreload<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> & { preload: () => Promise<{ default: T }> } {
  const Component = React.lazy(factory) as any;
  Component.preload = factory;
  return Component;
}